import { Icon, Tooltip, IconButton, Skeleton } from "@/components";
import { MobileTruncated } from "../text/MobileTruncated";

interface APYDisplayProps {
    rate: string;
    className?: string;
    tooltipText?: string;
    isLoading?: boolean;
}

export function APYDisplay({ rate, className, tooltipText, isLoading }: APYDisplayProps) {
    if (!rate) return null;

    if (isLoading) {
        return (
            <div className={`flex flex-col gap-1 md:flex-row md:items-center ${className}`}>
                <Skeleton variant="text" width={80} height={24} />
                <Skeleton variant="circular" width={16} height={16} />
            </div>
        );
    }

    return (
        <div className={`flex flex-col gap-1 md:flex-row md:items-center ${className}`}>
            <Tooltip title={tooltipText} className="relative">
                <div className="order-1 inline-flex items-center gap-1 md:order-2">
                    <span className="text-secondary sm:text-md text-sm">
                        <MobileTruncated desktopText="Projected" mobileMaxChars={4} nEllipsis={1} /> Net APY
                    </span>
                    <span className="inline-block cursor-help">
                        <IconButton size="sm" variant="ghost" className="p-0">
                            <Icon name="Info" className="text-dark text-xs w-[14px] h-[14px] " />
                        </IconButton>
                    </span>
                </div>
            </Tooltip>
            <span className="order-2 text-secondary sm:text-md text-sm md:order-1">{rate}%</span>
        </div>
    );
}
